export default function () {

    const vm = this;
    vm.snapshotChanged = snapshotChanged;

    function snapshotChanged(snapshot) {
        vm.onUpdate({ snapshot });
    }
}